function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 0c1.104569 0 2 .8954305 2 2v12c0 1.1045695-.895431 2-2 2H2c-1.104569 0-2-.8954305-2-2V2C0 .8954305.895431 0 2 0h12zm-3.323469 4.76040625H5.323469c-1.05025 0-1.901625.85140625-1.901625 1.901625v2.676c0 1.05025005.851406 1.90162505 1.901625 1.90162505h5.353062c1.05025 0 1.901625-.8514063 1.901625-1.90162505v-2.676c0-1.05021875-.851406-1.901625-1.901625-1.901625zM6.888781 6.6810625l2.50375 1.26878125c.074563.03771875.073219.1445-.002094.180375l-2.50375 1.194125c-.066749.03184375-.143843-.01675-.143843-.09065625V6.77075c0-.075.079125-.12359375.145937-.0896875z",
  fill: "#CCC",
  fillRule: "evenodd"
});

var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    className: "mx-1 c-neutral-200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.60cebfb9.svg";
export { ForwardRef as ReactComponent };